import { render, staticRenderFns } from "./RegistrationTunnel.vue?vue&type=template&id=8fba3dfa"
import script from "./RegistrationTunnel.vue?vue&type=script&lang=js"
export * from "./RegistrationTunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports